import { render } from "./RadioMenuAudioDialog.vue?vue&type=template&id=283b6fb4&scoped=true&ts=true"
import script from "./RadioMenuAudioDialog.vue?vue&type=script&lang=ts"
export * from "./RadioMenuAudioDialog.vue?vue&type=script&lang=ts"

import "./RadioMenuAudioDialog.vue?vue&type=style&index=0&id=283b6fb4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283b6fb4"]])

export default __exports__